export const HOME = {
  title: undefined,
  description: undefined,
  routes: ["/", "/home", "/about", "/index", "/index.html", "/timjames.dev"],
};

export const PROJECTS = {
  title: "Projects",
  description: "View my past projects, career events, and more.",
  routes: ["/projects", "/timeline"],
};

export const BLOG = {
  title: "Blog",
  description: "View my blog - web development, tech tips, and more.",
  routes: ["/blog", "/articles"],
};

export const CONTACT = {
  title: "Contact",
  description: "Find me on social media, or send me an email.",
  routes: ["/contact"],
};
